export default __webpack_public_path__ + "static/media/calendarBlue.752fdbb7.svg";